<template>
      <core-layout-content medium>
            <!-- Headline -->
            <core-layout-headline-and-actions>
                  <template slot="headline">{{ $t("create_client") }}</template>
            </core-layout-headline-and-actions>

            <j-card class="bg5 p5">
                  <!-- Form -->
                  <core-form-input
                        componentName="j-base-radios"
                        id="clientType"
                        name="clientType"
                        label="Select Type"
                        :options="[{name:'Individual',value:'individual'},{name:'Company',value:'company'}]"
                        v-model="form.clientType"
                  />

                  <!-- For Individuals -->
                  <div v-if="form.clientType === 'individual'">
                        <core-form-input
                              componentName="j-base-radios"
                              id="salutation"
                              name="salutation"
                              label="Salutation"
                              :options="salutationTypes"
                              v-model="form.salutation"
                              class="mt6"
                        />
                        <core-form-input
                              componentName="j-base-radios"
                              id="gender"
                              name="gender"
                              label="Gender"
                              :options="genderTypes"
                              v-model="form.gender"
                              class="mt6"
                        />
                        <div class="flex xs-12 mt6">
                              <div class="flex xs-6">
                                    <core-form-input
                                          componentName="j-base-input-text"
                                          id="englishFirstName"
                                          name="englishFirstName"
                                          label="First Name"
                                          subheadline="English"
                                          v-model="form.englishFirstName"
                                          class="pr2"
                                    />
                              </div>
                              <div class="flex xs-6">
                                    <core-form-input
                                          componentName="j-base-input-text"
                                          id="englishLastName"
                                          name="englishLastName"
                                          label="Last Name"
                                          subheadline="English"
                                          v-model="form.englishLastName"
                                          class="pl2"
                                    />
                              </div>
                        </div>

                        <div class="flex xs-12 mt6">
                              <div class="flex xs-6">
                                    <core-form-input
                                          componentName="j-base-input-text"
                                          id="chineseFirstName"
                                          name="chineseFirstName"
                                          label="First Name"
                                          subheadline="Chinese"
                                          v-model="form.chineseFirstName"
                                          class="pr2"
                                    />
                              </div>
                              <div class="flex xs-6">
                                    <core-form-input
                                          componentName="j-base-input-text"
                                          id="chineseLastName"
                                          name="chineseLastName"
                                          label="Last Name"
                                          subheadline="Chinese"
                                          v-model="form.chineseLastName"
                                          class="pl2"
                                    />
                              </div>
                        </div>

                        <core-form-input
                              componentName="j-base-input-text"
                              id="email"
                              name="email"
                              label="Email"
                              v-model="form.email"
                              class="mt6"
                        />
                        <core-form-input
                              componentName="j-base-input-text"
                              id="dateOfBirth"
                              name="dateOfBirth"
                              label="Date Of Birth"
                              subheadline="DD/MM/YYYY"
                              v-model="form.dateOfBirth"
                              class="mt6"
                        />
                        <core-form-input
                              componentName="j-base-input-text"
                              id="occupation"
                              name="occupation"
                              label="Occupation"
                              v-model="form.occupation"
                              class="mt6"
                        />
                        <core-form-input
                              componentName="j-base-radios"
                              id="maritalStatus"
                              name="maritalStatus"
                              label="Marital Status"
                              :options="maritalStatusTypes"
                              v-model="form.maritalStatus"
                              class="mt6"
                        />
                        <core-form-input
                              componentName="j-base-select"
                              id="countryOfResidency"
                              name="countryOfResidency"
                              label="Country Of Residency"
                              :options="countries"
                              v-model="form.countryOfResidency"
                              class="mt6"
                        />
                        <core-form-input
                              componentName="j-base-input-text"
                              id="preferredCommunicationChannel"
                              name="preferredCommunicationChannel"
                              label="Preferred Communication Channel"
                              v-model="form.preferredCommunicationChannel"
                              class="mt6"
                        />
                        <core-form-input
                              componentName="j-base-input-text"
                              id="preferredLanguage"
                              name="preferredLanguage"
                              label="Preferred Language"
                              v-model="form.preferredLanguage"
                              class="mt6"
                        />
                  </div>

                  <div v-if="form.clientType === 'company'">
                        <core-form-input
                              componentName="j-base-input-text"
                              id="name"
                              name="name"
                              label="Name"
                              v-model="form.name"
                              class="mt6"
                        />
                        <core-form-input
                              componentName="j-base-input-text"
                              id="natureOfBusiness"
                              name="natureOfBusiness"
                              label="Nature Of Business"
                              v-model="form.natureOfBusiness"
                              class="mt6"
                        />
                        <core-form-input
                              componentName="j-base-input-text"
                              id="registrationNumber"
                              name="registrationNumber"
                              label="Registration Number"
                              v-model="form.registrationNumber"
                              class="mt6"
                        />
                  </div>
            </j-card>

            <!-- Actions -->
            <j-button class="mt6" @click="handleCreate" :isLoading="isLoading">{{ $t("create") }}</j-button>
      </core-layout-content>
</template>

<script>
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions.vue"
import CoreFormInput from "@/modules/core/components/CoreFormInput.vue"
import JCard from "@/components/JCard/"
import JButton from "@/components/JButton/"
import api from "../api/"
import dayjs from "dayjs"
import get from "lodash.get"
import {
	countries,
	salutationTypes,
	genderTypes,
	maritalStatusTypes
} from "@/forms/enums.js"
import { transformDate } from "@/utils/"

export default {
	components: {
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		CoreFormInput,
		JCard,
		JButton
	},

	data() {
		return {
			isLoading: false,
			countries: countries,
			salutationTypes: salutationTypes,
			genderTypes: genderTypes,
			maritalStatusTypes: maritalStatusTypes,
			form: {
				clientType: "individual",
				//individuals

				salutation: null,
				gender: null,
				englishFirstName: null,
				englishLastName: null,
				chineseFirstName: null,
				chineseLastName: null,
				email: null,
				dateOfBirth: null,
				occupation: null,
				maritalStatus: null,
				countryOfResidency: null,
				preferredCommunicationChannel: null,
				preferredLanguage: null,

				//companies
				name: null,
				natureOfBusiness: null,
				registrationNumber: null
			}
		}
	},

	methods: {
		async handleCreate() {
			let apiKeys = null
			let payload = null

			let {
				salutation,
				gender,
				englishFirstName,
				englishLastName,
				chineseFirstName,
				chineseLastName,
				email,
				dateOfBirth,
				occupation,
				maritalStatus,
				countryOfResidency,
				preferredCommunicationChannel,
				preferredLanguage,
				name,
				natureOfBusiness,
				registrationNumber
			} = this.form

			if (this.form.clientType === "individual") {
				apiKeys = {
					request: "createIndividual",
					input: "createIndividualInput"
				}

				payload = {
					salutation,
					gender,
					englishFirstName,
					englishLastName,
					chineseFirstName,
					chineseLastName,
					dateOfBirth: dateOfBirth
						? transformDate(dateOfBirth)
						: null,
					email,
					occupation,
					maritalStatus,
					countryOfResidency,
					preferredCommunicationChannel,
					preferredLanguage,
					type: "CUSTOMER"
				}
			} else {
				apiKeys = {
					request: "createCompany",
					input: "createCompanyInput"
				}

				payload = {
					nameFormat: name,
					natureOfBusiness,
					registrationNumber,
					type: "CUSTOMER"
				}
			}

			this.isLoading = true

			const res = await api[apiKeys.request]({
				[apiKeys.input]: { ...payload }
			})

			this.isLoading = false

			// Error
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
			}

			this.$store.dispatch("addMessage", {
				message: {
					type: "success",
					text: this.$t("client_was_added"),
					link: {
						text: this.$t("see_clients_details"),
						to: `/${
							this.$store.state.tenantId
						}/clients/detail/${
							res.data[apiKeys.request]
								.createdStatus.id
						}/overview/${this.form.clientType}` // this.type returns "individual" or "company"
					}
				}
			})

			this.$router.back()
		}
	}
}
</script>
